export interface GalleryCollectionRow {
  id: string;
  member: string;
  group: string;
  amount: number;
  date: string;
  status: "paid" | "pending" | "overdue" | "partial";
}

export const GALLERY_COLLECTIONS: GalleryCollectionRow[] = [
  { id: "c-01", member: "Aarav Mehta", group: "Laxmi-12", amount: 100000, date: "2026-08-05", status: "paid" },
  { id: "c-02", member: "Divya Sharma", group: "Laxmi-12", amount: 100000, date: "2026-08-05", status: "paid" },
  { id: "c-03", member: "Rohan Verma", group: "Saraswati-08", amount: 50000, date: "2026-08-06", status: "partial" },
  { id: "c-04", member: "Pooja Nair", group: "Ganesh-03", amount: 25000, date: "2026-08-06", status: "pending" },
  { id: "c-05", member: "Karan Singh", group: "Laxmi-12", amount: 100000, date: "2026-08-07", status: "paid" },
  { id: "c-06", member: "Sneha Iyer", group: "Saraswati-08", amount: 50000, date: "2026-08-08", status: "overdue" },
  { id: "c-07", member: "Vivek Joshi", group: "Ganesh-03", amount: 25000, date: "2026-08-08", status: "paid" },
  { id: "c-08", member: "Meera Patel", group: "Laxmi-12", amount: 100000, date: "2026-08-09", status: "pending" },
  { id: "c-09", member: "Arjun Rao", group: "Saraswati-08", amount: 50000, date: "2026-08-10", status: "paid" },
  { id: "c-10", member: "Neha Kulkarni", group: "Ganesh-03", amount: 25000, date: "2026-08-11", status: "partial" },
  { id: "c-11", member: "Rahul Gupta", group: "Laxmi-12", amount: 100000, date: "2026-08-12", status: "overdue" },
  { id: "c-12", member: "Ananya Das", group: "Saraswati-08", amount: 50000, date: "2026-08-13", status: "paid" },
];

export const GALLERY_GROUP_OPTIONS = [
  { value: "laxmi-12", label: "Laxmi-12" },
  { value: "saraswati-08", label: "Saraswati-08" },
  { value: "ganesh-03", label: "Ganesh-03" },
  { value: "kali-05", label: "Kali-05" },
];

export const GALLERY_STATUS_OPTIONS = [
  { value: "paid", label: "Paid" },
  { value: "pending", label: "Pending" },
  { value: "overdue", label: "Overdue" },
  { value: "partial", label: "Partial" },
];